import { FC } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import IcCloseBold from 'src/assets/images/icCloseBold.svg';
import IcInventoryFill from 'src/assets/images/icInventoryFill.svg';
import GemImage from 'src/components/GemImage';
import useGemAmount from 'src/hooks/useGemAmount';
import { numComma } from 'src/utils/common';
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 20px 16px 8px;
`;
const HeaderIconButton = styled.button`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  width: 40px;
  height: 40px;
  margin: -8px;
  display: none;
  align-items: center;
  justify-content: center;
  color: ${({
  theme
}) => theme.color.content12};

  ${({
  theme
}) => theme.screenSize.mobile} {
    display: flex;
  }
`;
const CloseButton = HeaderIconButton;
const CloseIcon = styled(IcCloseBold)`
  width: 24px;
  height: 24px;
  ${({
  theme
}) => theme.isRtl && 'transform: scaleX(-1);'}
`;
const Title = styled.p`
  flex: 1;
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  color: ${({
  theme
}) => theme.color.content12};
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const GemPill = styled.div`
  display: none;
  align-items: center;
  gap: 4px;
  padding: 4px 6px;
  background-color: ${({
  theme
}) => theme.color.surface4};
  border-radius: 8px;

  ${({
  theme
}) => theme.screenSize.mobile} {
    display: flex;
  }
`;
const GemIcon = styled(GemImage)`
  width: 16px;
  height: 16px;
  ${({
  theme
}) => theme.isRtl && 'transform: scaleX(-1);'}
`;
const GemAmount = styled.span`
  font-size: 13px;
  font-weight: 700;
  line-height: 16px;
  color: ${({
  theme
}) => theme.color.content11};
  text-align: center;
  white-space: nowrap;
`;
const InventoryButton = HeaderIconButton;
const InventoryIcon = styled(IcInventoryFill)`
  width: 24px;
  height: 24px;
  ${({
  theme
}) => theme.isRtl && 'transform: scaleX(-1);'}
`;
interface Props {
  onClose: () => void;
  onInventoryClick: () => void;
}
const ShopHeader: FC<Props> = ({
  onClose,
  onInventoryClick
}) => {
  const {
    t
  } = useTranslation();
  const gemAmount = useGemAmount();
  return <HeaderContainer data-sentry-element="HeaderContainer" data-sentry-component="ShopHeader" data-sentry-source-file="ShopHeader.tsx">
      <CloseButton type='button' onClick={onClose} data-sentry-element="CloseButton" data-sentry-source-file="ShopHeader.tsx">
        <CloseIcon data-sentry-element="CloseIcon" data-sentry-source-file="ShopHeader.tsx" />
      </CloseButton>
      <Title data-sentry-element="Title" data-sentry-source-file="ShopHeader.tsx">{t('shop_title')}</Title>
      <GemPill data-sentry-element="GemPill" data-sentry-source-file="ShopHeader.tsx">
        <GemIcon data-sentry-element="GemIcon" data-sentry-source-file="ShopHeader.tsx" />
        <GemAmount data-sentry-element="GemAmount" data-sentry-source-file="ShopHeader.tsx">{numComma(gemAmount || 0)}</GemAmount>
      </GemPill>
      <InventoryButton type='button' onClick={onInventoryClick} data-sentry-element="InventoryButton" data-sentry-source-file="ShopHeader.tsx">
        <InventoryIcon data-sentry-element="InventoryIcon" data-sentry-source-file="ShopHeader.tsx" />
      </InventoryButton>
    </HeaderContainer>;
};
export default ShopHeader;